import React from "react";
import { Progress } from "@/components/ui/progress";
import { Check, Loader2, Circle } from "lucide-react";
import { useLang } from "@/contexts/AppContexts";

const STAGES = [
  { key: "upload", labelKey: "pipeline.uploading" },
  { key: "metadata", labelKey: "pipeline.metadata" },
  { key: "ela", labelKey: "pipeline.ela" },
  { key: "vision", labelKey: "pipeline.vision" },
  { key: "done", labelKey: "pipeline.done" },
];

const getStageIndex = (stage) => STAGES.findIndex((s) => s.key === stage);

const PipelineProgress = ({ stage = "upload", percent = 0 }) => {
  const { t } = useLang();
  const idx = getStageIndex(stage);

  return (
    <div className="space-y-3" data-testid="analysis-progress">
      <Progress value={percent} className="h-2" data-testid="analysis-progress-bar" />
      <div className="flex flex-wrap items-center gap-2">
        {STAGES.map((s, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <span
              key={s.key}
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs transition-colors ${
                done
                  ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-700 dark:text-emerald-200"
                  : active
                  ? "border-primary/40 bg-primary/10 text-foreground"
                  : "border-border bg-muted text-muted-foreground"
              }`}
              data-testid="analysis-progress-step"
            >
              {done ? (
                <Check className="h-3 w-3" />
              ) : active ? (
                <Loader2 className="h-3 w-3 animate-spin" />
              ) : (
                <Circle className="h-3 w-3" />
              )}
              <span className="font-medium">{t(s.labelKey)}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export { PipelineProgress };
export default PipelineProgress;
